import(/* webpackMode: "eager" */ "/root/hcs_admin/src/app/page.tsx");
